import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_pick_pack_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  flow_type: fromDatatype.VarcharDatatypeInterface;
  guid_doc_1_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_1_line: fromDatatype.GuidDataFieldInterface;
  server_doc_type_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_type_1: fromDatatype.VarcharDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  location_code: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  base_qty: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  queue_type: fromDatatype.VarcharDatatypeInterface;
  running_number: fromDatatype.VarcharDatatypeInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  acceptance_criterion: fromDatatype.VarcharDatatypeInterface;
  acceptance_deviation: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_pick_pack_queue_RowClass
  implements bl_fi_pick_pack_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  flow_type: fromDatatype.VarcharDatatypeInterface;
  guid_doc_1_hdr: fromDatatype.GuidDataFieldInterface;
  guid_doc_1_line: fromDatatype.GuidDataFieldInterface;
  server_doc_type_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_type_1: fromDatatype.VarcharDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  location_code: fromDatatype.VarcharDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  base_qty: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  queue_type: fromDatatype.VarcharDatatypeInterface;
  running_number: fromDatatype.VarcharDatatypeInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  acceptance_criterion: fromDatatype.VarcharDatatypeInterface;
  acceptance_deviation: fromDatatype.NumericDatatypeInterface;
}

